(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curasola-header"]) return;
  try {
    
document.addEventListener('click',function(event){const menu=document.querySelector('.cs-mobile-menu');if(menu&&menu.open&&!menu.contains(event.target))menu.open=false;});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){const menu=document.querySelector('.cs-mobile-menu');if(menu&&menu.open){menu.open=false;menu.querySelector('summary').focus();}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curasola-page"]) return;
  try {
    
document.addEventListener('click', function(event) {
 const button = event.target.closest('[data-cs-document-zoom]');
 if (!button) return;
 const reader = document.getElementById(button.getAttribute('aria-controls'));
 if (!reader) return;
 const enlarged = reader.classList.toggle('is-enlarged');
 button.setAttribute('aria-pressed', String(enlarged));
 button.textContent = enlarged ? button.dataset.fit : button.dataset.zoom;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curasola-product"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-cs-variant]'))return;const o=event.target.selectedOptions[0],r=event.target.closest('[data-cs-product]');if(!o||!r)return;const available=o.dataset.available==='true',labels=JSON.parse(document.getElementById('CurasolaProductLabels').textContent);r.querySelector('[data-cs-price]').textContent=o.dataset.price;document.querySelectorAll('[data-cs-sticky-price]').forEach(el=>el.textContent=o.dataset.price);r.querySelector('[data-cs-sku]').textContent=o.dataset.sku;r.querySelector('[data-cs-stock]').textContent=available?labels.available:labels.sold;const add=r.querySelector('[data-cs-add]');add.disabled=!available;add.textContent=available?labels.add:labels.sold;const qty=r.querySelector('[name="quantity"]');qty.max=Math.max(1,Number(o.dataset.stock));qty.value=Math.min(Number(qty.value),Number(qty.max));const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curasola-technology"]) return;
  try {
    
(function () {
  const format = new Intl.NumberFormat(document.documentElement.lang || 'de', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
  const integer = new Intl.NumberFormat(document.documentElement.lang || 'de', { maximumFractionDigits: 0 });
  function initialize(root) {
    if (root.dataset.ctInitialized) return;
    root.dataset.ctInitialized = 'true';
    const motion = root.querySelector('[data-motion-toggle]');
    if (motion) {
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = preference.matches;
      function setMotion() {
        root.classList.toggle('is-motion-paused', paused);
        motion.setAttribute('aria-pressed', String(paused));
        motion.textContent = paused ? motion.dataset.playLabel : motion.dataset.pauseLabel;
      }
      // An explicit play action may enable this isolated illustration even when
      // the OS prefers reduced motion; the default always respects the OS.
      motion.addEventListener('click', function () {
        paused = !paused;
        const fronts = root.querySelector('.ct-pressure-fronts');
        if (fronts) fronts.style.animation = paused ? 'none' : 'ct-wave-flow 2.8s linear infinite';
        setMotion();
      });
      setMotion();
    }
    root.querySelectorAll('[data-ct-depth]').forEach(function (widget) {
      let frequency = 10;
      const input = widget.querySelector('input[type="range"]');
      function update() {
        const z = Number(input.value);
        const half = frequency === 10 ? 3 : 1.35;
        const fraction = Math.pow(2, -z / half);
        widget.classList.toggle('is-19', frequency === 19);
        widget.querySelectorAll('[data-frequency]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(Number(button.dataset.frequency) === frequency));
        });
        widget.querySelectorAll('[data-curve]').forEach(function (curve) {
          curve.classList.toggle('is-selected', Number(curve.dataset.curve) === frequency);
        });
        widget.querySelector('[data-selected-frequency]').textContent = String(frequency);
        widget.querySelector('[data-half-value]').textContent = widget.querySelector('[data-half-' + frequency + ']').textContent;
        widget.querySelector('[data-depth-value]').textContent = format.format(z) + ' mm';
        widget.querySelector('[data-intensity-value]').textContent = integer.format(fraction * 100) + ' %';
        input.setAttribute('aria-valuetext', format.format(z) + ' mm');
        const x = 64 + z * 100;
        widget.querySelector('[data-depth-cursor]').setAttribute('d', 'M' + x + ' 58V298');
        const dot = widget.querySelector('[data-depth-dot]');
        dot.setAttribute('cx', String(x));
        dot.setAttribute('cy', String(298 - 240 * fraction));
        widget.querySelector('[data-band-note]').hidden = frequency !== 19;
        widget.querySelector('[data-range-value]').textContent = integer.format(Math.pow(2, -z / 1.2) * 100) + '–' + integer.format(Math.pow(2, -z / 1.5) * 100) + ' %';
      }
      input.addEventListener('input', update);
      widget.querySelectorAll('[data-frequency]').forEach(function (button) {
        button.addEventListener('click', function () { frequency = Number(button.dataset.frequency); update(); });
      });
      update();
    });
    root.querySelectorAll('[data-ct-pulse]').forEach(function (widget) {
      widget.querySelectorAll('[data-duty]').forEach(function (button) {
        button.addEventListener('click', function () {
          const duty = Number(button.dataset.duty);
          widget.querySelectorAll('[data-duty]').forEach(function (item) { item.setAttribute('aria-pressed', String(Number(item.dataset.duty) === duty)); });
          widget.querySelectorAll('[data-pulse-bars] rect').forEach(function (bar) { bar.setAttribute('width', String(125 * duty / 100)); });
          widget.querySelector('[data-duty-output]').textContent = String(duty);
          widget.querySelectorAll('[data-pulse-copy]').forEach(function (copy) { copy.hidden = Number(copy.dataset.pulseCopy) !== duty; });
        });
      });
    });
  }
  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-ct-root]')) initialize(scope);
    scope.querySelectorAll('[data-ct-root]').forEach(initialize);
  }
  initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();


  } catch(e) { console.error(e); }
})();
})();
